<div class="px-3 py-2">
	<h4 align="center">HisTO26 - History of Cryptography in Turin</h4>
	<p><a href="https://sites.google.com/view/histo26/home" target="_blank">sites.google.com/view/histo26/home</a></p>

	<p>
		<b>HisTo26</b> explores the evolution of secret writing, spanning the entire history of the
		discipline: from Classical and Renaissance ciphers to World War II and cold war
		cryptanalysis.
	</p>

	<ul>
		<li>Cryptography, cryptanalysis and applications</li>
		<li>Ancient and historical ciphers</li>
		<li>Analysis of historical documents / cases</li>
	</ul>
</div>